(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react"], factory);
	else if(typeof exports === 'object')
		exports["GigCard"] = factory(require("@fiverr/globals"), require("react"));
	else
		root["GigCard"] = factory(root["@fiverr/globals"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition